<template>
    <div v-if="body_show">
        <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>
        <!-- head -->
        <div class="ceping-head">
            <div class="head-text">
                <p>你是否：常为了赢得认同而压抑自身想法？不自觉隐藏自己的真实性格？常因他人反应而感觉受伤？常把自己的主观情感当作实际情况？如果以上表现你中了2条以上，您的自我分化程度较低。</p>
                <p>自我分化是Bowen家庭系统理论的核心概念，指个体在家庭中情绪依恋与独立自主的程度，简单来说就是在保持亲密的同时，不为保持亲密而放弃自我，也不为追求自我而放弃亲密关系。</p>
            </div>
        </div>
        <div class="small-title">
            以下是你的专属结果海报，快发给朋友看看准不准吧
            <!-- 原生家庭对你的影响度海报 -->
            <img class="effect" :src="data.poster">
        </div>

        <!-- 自我分化总体指数 -->
        <div class="overall-main">
            <div class="overall-index">第一部分：自我分化总体指数</div>
            <div id="dashboard" class="dashboard"></div>
            <h2 class="h2">根据测评结果，您的分化水平得分为: <span class="em">{{data.score}}</span></h2>
            <h2 class="h2">分化关键词: <span class="em">{{data.report.title_text0}}</span></h2> 
        </div>
        <!-- 第二部分 -->
        <div class="overall-main">
            <div class="overall-index">第二部分：自我分化维度剖解</div>
            <h2 class="h2 tl">根据Bowen的理论，自我分化包括内心和人际关系两个层面，共四个维度。你在四个维度上的得分如下：</h2>
            <div id="dimension" class="dimension"></div>
            <div class="subtitle">1.内心层面</div>
            <p class="text">自我分化是个体区分理智和情绪进行的一种能力，即在特定的时刻，个体的行为是受理智还是受情绪的支配，标志着个体的情绪成熟程度。包括以下两个维度：</p>
            <p class="text"><span class="blue">1.1 {{data.result[0].division}}</span></p>
            <div class="editor-text" v-html="data.result[0].explaining"></div>
            <p class="text"><span class="blue">1.2 {{data.result[1].division}}</span></p>
            <div class="editor-text" v-html="data.result[1].explaining"></div>
            <div class="split"></div>

            <div class="subtitle">2.人际层面</div>
            <p class="text">自我分化是个体的人际互动关系的能力的体现，个体在与他人的人际关系中，可以很容易感受到彼此亲密的感觉，同时又不会轻易失去自身的独立性。包括以下两个维度：</p>
            <p class="text"><span class="blue">2.1 {{data.result[2].division}}</span></p>
            <div class="editor-text" v-html="data.result[2].explaining"></div>
            <p class="text"><span class="blue">2.2 {{data.result[3].division}}</span></p>
            <div class="editor-text" v-html="data.result[3].explaining"></div>
        </div>
        <!-- 福利 -->
        <div class="overall-main pb gg">
            <!-- begin 插入广告组件 -->
            <public-advertising></public-advertising>
            <!-- <div class="subtitle welfare">分享好友，听讲座</div> -->
            <!-- <img class="iverall-img" src="@a/c47_fuli.jpg">
            <p>
                <strong class="bold">扫码添加微信（微信号 czplan12）</strong> <br>
                <strong class="bold">回复“职业发展”</strong> <br>
                <strong class="bold">获取「个人成长工具包」</strong> <br>
                <strong class="bold">获取「原生家庭与职场」专题讲座链接</strong>
            </p> -->
            <!-- <img  class="iverall-img" src="@a/ceping47_market.jpg">
            <div class="poster-abs" v-if="show_market">
                <img src="@a/ceping47_market_qrcode.png">
                <span>听讲座请扫二维码</span>
            </div>
            <div class="poster-abs" v-else>
                <span>点击右上角 … <br> 转发测评给2位好友或微信群<br> 获得二维码，免费听讲座</span>
            </div>-->
        </div> 
        <public-ad-qrcode></public-ad-qrcode>
        <!-- 关注二维码 -->
        <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
            <img v-if="is_main" class="qr-box" src="../../../assets/career_ceping47.jpg" />
            <img v-else class="qr-box" src="../../../assets/coach_ceping47.jpg" />
        </van-popup>
    </div>
</template>

<script>
import { ceping47_report } from "@/api/measurement";
import { shareCon,getNickName } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import { getStorage, setStorage,isMain } from "@/utils/tools";
import { setTimeout } from 'timers';

import PublicAdvertising from "@c/measurement/public-advertising";
import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
    data(){
        return{
            body_show:false,
            data:{},
            show_market:false,
            type_obj: {
                evaluation_id: "",
                evaluation_name: "",
                evaluation_id: ""
            },
            isShow:false
        }
    },
    computed: {
        is_main(){
            return isMain()
        }
    },
    components: {
      PublicAdvertising,
      PublicAdQrcode,
      PublicTopTips,
    },
    mounted(){
        let path = this.$route.path;
        let show_market = getStorage(path, 'show_market') || '';
        if(show_market == 'show') {
            this.show_market = true;
        }
    },
    methods:{
        set_show_market(){
            setStorage(this.$route.path, 'show_market', 'show');
            this.show_market = true;
        },
        // 维度剖析
        dimension_chart(){
            let dimension = echarts.init(document.getElementById('dimension'));
            let dimension_indicator = [];
            let dimension_value = [];
            for (let i = 0; i < this.data.result.length; i++) {
                let item = this.data.result[i];
                dimension_indicator.push({text: item.division, max: 4});
                dimension_value.push(item.avg);
            }
            let option = {
                tooltip : {
                    trigger: 'axis'
                },
                polar : [
                    {
                        indicator : dimension_indicator
                    }
                ],
                series : [
                    {
                        type: 'radar',
                        itemStyle: {
                            normal: {
                                areaStyle: {
                                    type: 'default'
                                }
                            }
                        },
                        data : [
                            {
                                name: '得分',
                                value : dimension_value,
                                label: {
                                    normal: {
                                        show: true,
                                        formatter:function(params) {
                                            return params.value;
                                        }
                                    }
                                }
                            }
                        ]
                    }
                ]
            };

            // 为echarts对象加载数据
            dimension.setOption(option);
        },
        // 自我分化总体指数
        dashboard_chart(){
            let myChart = echarts.init(document.getElementById('dashboard'));
            window.onresize = myChart.resize;
            let option =  {
                    center: ['80%', '50%'],
                    series: [{
                        type: 'gauge',
                        radius: '90%',
                        animationDurationUpdate: 1500,
                        animationEasingUpdate: 'quadraticOut',
                        detail: {
                            textStyle: {
                                fontSize: 24
                            },
                            offsetCenter: [0, '68%']
                        },
                        splitLine: { //分割线样式
                            length: 20
                        },
                        pointer: {
                            length: '60%',
                            width: 4

                        },
                        axisLine: {
                            lineStyle: {
                                color: [
                                    [0.3, '#EF735B'],
                                    [0.55, '#EEB763'],
                                    [0.75, '#B4D39E'],
                                    [1, '#6DABF1']
                                ],
                                width: 20 // 这个是修改宽度的属性
                            }
                        },
                        data: [{
                            value: ''
                        }]
                    }]
                };
            myChart.setOption(option);
            myChart.setOption({
                series: [
                    {
                        name: '自我分化总体指数',
                        type: 'gauge',
                        data: [{value: this.data.score}]
                    }
                ]
            });
        },
        pullData() {
            ceping47_report({
                token:this.$route.query.token
            })
            .then((data) => {
                this.data = data;
                if (data.code != '10002') {
                    document.title = data.headtitle;
                    this.body_show = true;
                    // 给wxconfig传对象
                    this.type_obj.nickname = data.nickname;
                    this.type_obj.evaluation_id = data.report.cid;
                    this.type_obj.evaluation_name = data.headtitle;
                    this.type_obj.evaluation_user_id = String(data.uid);
                    this.type_obj.path = this.$route.path;

                    shareCon("ceping47", this, this.type_obj);


                    if(!data.subscribe && data.need_subscribe){
                        this.isShow = true;
                    }


                    setTimeout(()=>{
                        // 第一部分
                        this.dashboard_chart();
                        // 第二部分，维度剖析
                        this.dimension_chart();
                    },1000);
                }else {
                    // 已经测评完成
                    this.$router.push({
                        path: '/ceping47',
                        query:{
                            cid:this.$route.query.cid
                        }
                    })
            }
            })
        }
    },
    created() {
      this.pullData();
    }
}
</script>

<style lang="scss" scoped>
    //头部介绍
    .ceping-head{
        margin-bottom: 30px;
        background: url(../../../assets/c47_banner.png) no-repeat top center;
        background-size: 100%;
        padding: 30px 30px 0 30px;
    }
    .head-text{
        padding: 50px 20px;
        background: #fff;
        border-radius: 8px;
        position: relative;
        p{
            font-size: 28px;
            line-height: 48px;
            text-align: justify;
            color: #333;
            font-weight: 400;
            padding-top: 20px;
        }
    }
    .head-text:before{
        content: '“';
        position: absolute;
        top: 30px;
        left: 10px;
        color: #2780E0;
        font-size: 82px;
        line-height: 82px;
        font-weight: 500;
    }
    .head-text:after{
        content: '”';
        position: absolute;
        bottom: -30px;
        right: 10px;
        color: #2780E0;
        font-size: 82px;
        line-height: 82px;
        font-weight: 500;
    }
    // 第一部分：自我分化总体指数
    .overall-main{
        margin: 0 30px 30px 30px;
        border-radius: 8px;
        background-color: #fff;
        text-align: center;
        padding: 50px 20px;
        .overall-index{
            display: inline-block;
            vertical-align: bottom;
            margin: 0 auto;
            color: #333;
            font-weight: 500;
            font-size: 36px;
            line-height: 38px;
            padding: 20px;
            border-top: 4px solid #2780E0;
            border-bottom: 4px solid #2780E0;
            margin-bottom: 50px;
            position: relative;
        }
        .overall-index:after{
            content:'';
            width: 0;
            height: 0;
            border-width: 30px 30px 0;
            border-style: solid;
            border-color: #2780E0 transparent transparent;
            position: absolute;
            bottom: -50px;
            left: 50%;
            transform: translateX(-50%);
        }
        // 仪表盘
        .dashboard{
            height: 400px;
            margin: 0 auto;
        }
        .h2{
            text-align: center;
            font-size: 28px;
            line-height: 48px;
            color: #333;
            font-weight: 400;
            padding-top: 20px;
            .em{
                color: #FB5717;
                font-size: 36px;
            }
        }
        .split{
            height: 1px;
            border-bottom: 1px dashed #2780E0;
            margin: 30px auto;
        }
        .tl{
            text-align: left;
        }
        .dimension{
            margin: 0 auto;
            height: 430px;
            margin: 30px auto;
            -webkit-tap-highlight-color: transparent;
            user-select: none;
            position: relative;
        }
        .subtitle{
            display: inline-block;
            vertical-align: bottom;
            margin: 0 auto;
            width: auto;
            height: 60px;
            font-size: 26px;
            color: #fff;
            font-weight: 500;
            line-height: 30px;
            padding: 15px 60px;
            background: #2780E0;
            border-radius: 30px;
            position: relative;
        }
        .text{
            font-size: 26px;
            line-height: 48px;
            text-align: justify;
            color: #333;
            font-weight: 400;
            padding-top: 20px;
            .blue{
                color: #2780E0;
            }
        }
        .welfare{
            background: #FB5717;
            padding: 15px 75px;
        }
        .welfare:before{
            content: ' ';
            background: url(../../../assets/c47_icon.png) no-repeat center;
            background-size: 100%;
            width: 44px;
            height: 60px;
            position: absolute;
            top: 50%;
            left: -60px;
            transform: translateY(-50%);
        }
        .welfare:after{
            content: ' ';
            background: url(../../../assets/c47_icon.png) no-repeat center;
            background-size: 100%;
            width: 44px;
            height: 60px;
            position: absolute;
            top: 50%;
            right: -60px;
            transform: translateY(-50%);
        }
        // 福利
        .iverall-img{
            width: 100%;
            margin: 50px auto 30px;
        }
        p{
            line-height: 48px;
            text-align: center;
            color: #333;
            padding-top: 20px;
            .bold{
                font-size: 32px;
                line-height: 40px;
                color: #2780E0;
            }
        }
        .poster-abs{
            margin: 0 auto;
            position: relative;
            img{
                position: absolute;
                left:50px;
                bottom: 50px;
                width: 100px;
                height: 100px;
            }
            span{
                position: absolute;
                left: 170px;
                bottom: 50px;
                font-size: 25px;
                line-height: 38px;
                color: #333;
                text-align: left;
            }
        }
    }
    .pb{
        padding-bottom: 0;
    }
    .gg{
        padding: 0;
    }
    .effect{
        width: 100%;
        max-width: 750px;
        margin-top: 30px;
    }
    .small-title{
        font-size: 34px;
        font-weight: bold;
        color: #333;
        background-color: #fff;
        padding:30px;
        margin: 0 30px 30px 30px;
        border-radius:8px;
    }
    .qr-box{
        width:600px;
    }
</style>
<style>
    .editor-text p,.editor-text strong,.editor-text span{
        text-align: left !important;
        padding-top: 10px !important;
        font-size: 26px !important;
        font-weight: normal !important;
        line-height: 48px !important;
        font-family: sans-serif !important;
    }
</style>
